import { PaymentSourceEnum } from '../../enum';

/**
 * Defines the minimum required input parameters for the fee calculation logic.
 */
export interface SurfboardFeeCalculationInput {
  merchantId: number | string;
  source: PaymentSourceEnum;
  product?: string;
  baseAmount?: number;
  totalCards?: number;
  amount: number;
  description?: string;
}

/**
 * Defines the output structure for the isolated calculation method.
 */
export interface FeeCalculationResult {
  baseFee: number;
  vatFee: number;
  totalFee: number;
  netAmount: number;
}